import { t } from '@lingui/macro'
import { useMemo } from 'react'
import { useTheme } from 'styled-components'

import { Margin } from '@/@bothrs-ui/web/components/layout/index'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { AnimatedErrorContainer, StErrorText } from './NotFoundError.styled'

type NotFoundErrorProps = {
  onClick: () => void
}

const NotFoundError = ({ onClick }: NotFoundErrorProps) => {
  const theme = useTheme()

  // Template Variables
  // ------------------------------------------------------------------------- /
  const animationVariants = useMemo(
    () => ({
      slideLeft: {
        opacity: 0,
        x: '100%',
      },
      visible: {
        opacity: 1,
        x: 0,
      },
      slideRight: {
        opacity: 0,
        x: '-100%',
      },
    }),
    [],
  )

  return (
    <AnimatedErrorContainer
      key='error-section'
      variants={animationVariants}
      initial='slideLeft'
      animate='visible'
      exit='slideLeft'
      transition={{ type: 'spring', bounce: 0.1, duration: 0.4 }}
    >
      <img src='/img/svg/timeline-error.svg' alt='' />
      <Margin mb={theme.UI.Spacing.Space7} />
      <H2>
        {t({
          id: 'errors.not-found.title',
          comment: 'Something went wrong',
          message: 'Er gaat iets mis',
        })}
      </H2>
      <StErrorText type='BodyLargeRegular' textAlign='center'>
        {t({
          id: 'errors.not-found.body',
          comment: 'Generic error message',
          message:
            'We kunnen de juiste informatie helaas niet weergeven. Check je internetverbinding en probeer de pagina opnieuw te laden.',
        })}
      </StErrorText>
      <Margin mb={theme.UI.Spacing.Space8} />
      <Button variant='Primary' onClick={onClick}>
        {t({
          id: 'globals.try-again',
          comment: 'Try again',
          message: 'Probeer opnieuw',
        })}
      </Button>
    </AnimatedErrorContainer>
  )
}

export { NotFoundError }
